import jQuery from 'jquery';

/**
 * @classdesc
 * Toogle-Split-Button-Widget (Button mit einer kombinierten Auswahlliste zum toggeln).
 *
 * @class
 * @extends gc.gis.widget.GCSplitButton
 * @memberof gc.gis.widget
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object<string,*>} options Aufrufoptionen
 * @param {gc.gis.widget.GCSplitButtonOption[]} [options.options] Liste von Elementen.
 */
gc.gis.widget.GCToggleSplitButton = function(options)
{
	gc.gis.widget.GCSplitButton.call(this, options);

	/**
	 * Flag, ob der Toggle-Button gerade aktiv oder deaktiv ist.
	 * @type {boolean}
	 * @private
	 */
	this._active = false;
};
gc.gis.widget.GCToggleSplitButton.prototype = Object.create(gc.gis.widget.GCSplitButton.prototype);

/**
 * @inheritdoc
 */
gc.gis.widget.GCToggleSplitButton.prototype.setActive = function(active)
{
	gc.gis.widget.GCSplitButton.prototype.setActive.call(this, active);

	if(active)
	{
		this.element_control.addClass('active').addClass('gc-active');
		this._active = true;
	}
	else
	{
		this.element_control.removeClass('active').removeClass('gc-active');
		this._active = false;
	}
};

/**
 * Initialisiert die Events des Buttons.
 *
 * @private
 */
gc.gis.widget.GCSplitButton.prototype._initEventsButton = function()
{
	var self = this;

	// Klick auf den Button
	this.element_control.click(function (evt) {
		evt.preventDefault();
		try
		{
			self.setActive(!self._active);  // bevor die weiteren Handler ausgeführt werden, muss der aktuelle Status korrekt gesetzt sein

			if (self.action)
			{
				self.action.execute(self);
			}
			if (typeof self.click === 'function')
			{
				self.click.call(self, evt, self);
			}
		}
		catch (err)
		{
			gc.gis.iface.log.error(self, err);
		}
		jQuery(this).blur();
	});
};